import * as Sentry from '@sentry/react';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LEVEL_PRIORITY: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

const currentLevel: LogLevel = import.meta.env.PROD ? 'warn' : 'debug';

function shouldLog(level: LogLevel): boolean {
  return LEVEL_PRIORITY[level] >= LEVEL_PRIORITY[currentLevel];
}

function captureToSentry(args: unknown[]) {
  const error = args.find((a) => a instanceof Error);
  if (error) {
    Sentry.captureException(error);
  } else {
    Sentry.captureMessage(args.map(String).join(' '), 'error');
  }
}

export const logger = {
  debug(...args: unknown[]) {
    if (shouldLog('debug')) console.debug(...args);
  },
  info(...args: unknown[]) {
    if (shouldLog('info')) console.info(...args);
  },
  warn(...args: unknown[]) {
    if (shouldLog('warn')) console.warn(...args);
  },
  error(...args: unknown[]) {
    if (shouldLog('error')) console.error(...args);
    captureToSentry(args);
  },
};
